/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/CustomIdentifierSet/ResourceTemplate
 * @desc Action to set CustomIdentifierSet for a ResourceTemplate
 */

import { CustomIdentifierSetActionCreate } from 'labstep-web/components/CustomIdentifierSet/Action/Create';
import { CustomIdentifierSetPreview } from 'labstep-web/components/CustomIdentifierSet/Preview';
import { useHasAccessCreate } from 'labstep-web/components/Entity/Can/hooks';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import { CustomIdentifierSet } from 'labstep-web/models/custom-identifier-set.model';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { GroupFormShowEditCustomShowIdentifierSetResourceTemplateProps } from './types';

export const GroupFormShowEditCustomShowIdentifierSetResourceTemplate: React.FC<
  GroupFormShowEditCustomShowIdentifierSetResourceTemplateProps
> = ({ group, resource }) => {
  const canCreate = useHasAccessCreate(
    CustomIdentifierSet.entityName,
    resource.permission_entity_info?.entityName,
    resource.permission_entity_info?.id,
  ) as boolean;

  if (resource.custom_identifier_set) {
    return (
      <CustomIdentifierSetPreview
        customIdentifierSet={resource.custom_identifier_set}
        canCreate={canCreate}
      />
    );
  }
  if (canCreate && group) {
    return (
      <EntityUpdateContainer
        entityName={Resource.entityName}
        id={resource.id}
      >
        {({ update }) => (
          <CustomIdentifierSetActionCreate
            groupId={group.id}
            parentClass={resource.entityName}
            onSuccess={update}
          />
        )}
      </EntityUpdateContainer>
    );
  }
  return <TextPlaceholder>No Custom Identifier</TextPlaceholder>;
};
